








import { IndicatorInfo } from '@/services/analyzeCustom';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import CustomFunnelView from './custom-funnel-view.vue';
@Component({
  components: { CustomFunnelView }
})
export default class PreviewChart extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() formData!: any;
  @Prop() info!: IndicatorInfo;

  bodyStyle = { backgroundColor: '#EEE'};
}
